<template>
  <div>
    <div class="content-wrapper" v-loadmore="loadMore">
      <h4 class="title-t">评价<span class="fabu" @click="showPingLunDialogFunc(null)"><i class="iconfont icon-write"></i> 发布评价</span></h4>
      <div class="content">
        <div class="item" v-for="(item) in commentList" :key="item.id">
          <div class="head">
            <div class="col col-1">
              <img v-lazy="item.avatar">
            </div>
            <div class="col col-2">{{item.username}}</div>
            <div class="col col-3"><stars :num="Number(item.stars)||5" starStyle="font-size:13px;margin:0 2px;"></stars></div>
          </div>
          <div class="txt">{{item.content}}</div>
          <div class="time">
            <div class="col col-1">{{item.createtime}}</div>
            <div class="col col-2">
              <span @click="showPingLunDialogFunc(item)">回复</span>
              <!-- <span @click="showPingLunDialogFunc(item)"><i class="iconfont icon-pinglun1"></i></span> -->
              <!-- <span @click="_zanComment(item)" :class="{active: item.is_like}"><i class="iconfont icon-zan"></i> {{item.likes}}</span> -->
            </div>
          </div>
          <!-- 子评论 -->
          <div class="reply" v-if="item.child && item.child.length">
            <div class="reply-item" v-for="(item2) in item.child" :key="item2.id">
              <span class="username">{{item2.username}}: </span>{{item2.content}}
            </div>
          </div>
        </div>
        <loading :more="more" :loaded="loaded"></loading>
      </div>
    </div>
    <!-- 评论 -->
    <!-- <div class="pinglun-dialog-wrap" v-if="showPingLunDialog">
      <div class="mask"></div>
      <div class="content">
        <div class="title">评论</div>
        <div class="input-wrap">
          <textarea placeholder="请输入内容, 内容限制在140字符以内" v-model="commentContent" @focus="controlVideoShow(true)" @blur="controlVideoShow(false)"></textarea>
        </div>
        <div class="btns">
          <div class="col col-1" @click="commonSubmitComment()">提交</div>
          <div class="col col-1" @click="showPingLunDialog=false;commentContent=''">取消</div>
        </div>
      </div>
    </div> -->
    <div class="pinglun-dialog-wrap" v-if="showPingLunDialog">
      <div class="mask"></div>
      <div class="content-t">
        <!-- 评论其实就是代表回复别人的评价 -->
        <div class="title">{{subCommentItem ? '评论' : '评价'}}</div>
        <div style="margin-bottom:16px" v-if="!subCommentItem"><stars starStyle="font-size:20px;padding:0 5px;" ref="stars"></stars></div>
        <div class="input-wrap">
          <textarea ref="input" placeholder="请输入内容, 内容限制在140字符以内" v-model="commentContent" @focus="controlVideoShow(true)" @blur="controlVideoShow(false)"></textarea>
        </div>
        <div class="btns">
          <div class="ok" @click="commonSubmitComment()">{{'提交'}}</div>
          <div class="cancel" @click="showPingLunDialog=false;$emit('controlVideo', 'show');commentContent=''"><i class="iconfont icon-cha"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Scroll from 'components/base/scroll/scroll'
import {getCommentList, submitComment} from '@/api/play.js'
import {zanComment} from '@/api/user-behavior.js'
import {RES_OK} from '@/api/config'
import Loading from '../base/loading/loading2'
import Stars from 'components/base/ui/stars'
export default {
  props: {
    videoId: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    bought: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: '课程评价',
      page: 1,
      loaded: false,
      more: true,
      commentList: [],
      commentContent: '',
      showComment: true,
      // 是否显示评论对话框
      showPingLunDialog: false,
      // 子评论项,用来判读是 评论还是回复
      subCommentItem: null
    }
  },
  created() {
    // 获取评论内容
    this._getCommentList()
  },
  activated() {
    // this.$emit('setTitle', this.title)
    // this.$emit('appendComment', this.commentList)
  },
  mounted() {
  },
  methods: {
    _getCommentList() {
      this.loaded = false
      getCommentList(this.courseId, this.videoId, this.page).then(res => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          if (data.data.length) {
            this.commentList.push(...data.data)
            this.loaded = true
            this.page++
            this.more = data.data.length >= 8
          } else {
            // 加载完毕
            this.more = false
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    submitComment() {
      if (!this.commentContent) {
        this.$toast('评论内容不能为空')
        return
      }
      // 现在评论等价于评价来着，有个评分的选项
      const stars = this.$refs.stars.getStars()
      submitComment(this.commentContent, this.courseId, this.videoId, '' /* 回复帖子id,这里是评论不要传 */, stars).then(res => {
        let data = res.data
        if (data && data.code === RES_OK) {
          // 设置回复，以防发布回复报错
          // 直接设置，刚发布的评论这个时候肯定没有回复的
          data.data.child = []
          this.commentList.unshift(data.data)
          this.commentContent = ''
          this.showPingLunDialog = false
          this.$toast('评论成功', {
            durtaion: 200
          })
        } else {
          this.$toast(data.msg)
        }
      })
    },
    loadMore() {
      if (this.more && this.loaded) {
        this.loaded = false
        this._getCommentList(this.page)
      }
    },
    _zanComment(item) {
      zanComment(item.id).then(res => {
        let data = res.data
        if (data.code === RES_OK) {
          item.is_like = !item.is_like
          if (item.is_like) {
            item.likes++
          } else {
            item.likes--
          }
        }
      })
    },
    // 显示评论弹框
    showPingLunDialogFunc(item) {
      // item null 代表是发表评论
      // item 不为空 说明是回复评论
      this.showPingLunDialog = true
      this.subCommentItem = item
      this.$nextTick(() => {
        // console.log(this.$refs.input)
        if (this.$refs.input) {
          this.$refs.input.focus()
        }
      })
      // 控制父元素的播放器
      this.$emit('controlVideo', 'hide')
    },
    // 处理提交按钮事件
    commonSubmitComment() {
      if (this.subCommentItem) {
        // 回复
        this.submitSubComment(this.subCommentItem)
      } else {
        // 评论
        this.submitComment()
      }
    },
    // 评论二级回复
    submitSubComment(item) {
      if (!this.commentContent) {
        this.$toast('回复内容不能为空')
        return
      }
      submitComment(this.commentContent, this.courseId, this.videoId, item.id).then(res => {
        let data = res.data
        if (data.code === RES_OK) {
          this.commentContent = ''
          item.child.unshift(data.data)
          // this.$forceUpdate()
          this.showPingLunDialog = false
          this.$toast('回复成功', {
            durtaion: 200
          })
        } else {
          this.$toast(data.msg)
        }
      })
    },
    // 控制父组件视频显示或隐藏
    controlVideoShow(bool) {
      // 判断是苹果手机还是安卓手机, 如果是安卓手机
    }
  },
  components: {
    Scroll,
    Loading,
    Stars
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .content
    padding 0 size(30) size(120)
  .title-t
    padding size(40) size(30) size(10)
    font-size size(34)
    .fabu
      color $color-theme
      float right
      font-size size(28)
      font-weight 500
      padding-left size(20)
      font-weight 800
      .iconfont
        font-size 14px
  .item{
    position relative
    padding-bottom size(40)
    padding-top size(30)
    .head{
      display table
      width 100%
      height size(56)
      .col{
        display table-cell
        vertical-align middle
      }
      .col-1{
        width size(56)
        height size(56)
        img{
          width 100%
          height 100%
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
        }
      }
      .col-2{
        padding-left size(20)
        font-size size(30)
        font-weight 600
      }
      .col-3{
        width size(200)
        text-align right
      }
    }
    .txt{
      padding-top: size(20)
      padding-bottom size(20)
      font-size: size(30)
      line-height 1.5
      word-wrap break-word
      word-break break-all
    }
    .time{
      display table
      width 100%
      font-size size(26)
      .col{
        display table-cell
        vertical-align middle
        width 50%
      }
      .col-1{
        text-align left
        color #b3b3b3
      }
      .col-2{
        text-align right
        span{
          color #999
          display inline-block
          padding-left 10px
          i.icon-pinglun1{
            font-size size(34)
            color #000
          }
        }
        span.active{
          color: $color-theme
        }
      }
    }
    .sub-comment{
      margin-top: size(30)
      .wrap{
        display table
        width: 100%
        height: size(60)
        .col{
          display table-cell
          vertical-align middle
          height size(60)
        }
        .col-1{
          widht calc(100% - 3em)
          .textarea{
            width: 100%
            background-color: #f0f0f0
            outline:none
            resize:none
            border: none
            font-size size(28)
            padding: size(0) size(20)
            height size(60)
            vertical-align bottom
            -webkit-border-radius: size(10)
            -moz-border-radius: size(10)
            border-radius: size(10)
            resize none
          }
        }
        .col-2{
          width 3em
          text-align right
          color $color-theme
        }
      }
    }
    .reply{
      width 100%
      margin-top: size(30)
      .reply-item{
        margin-top: size(10)
        background-color: #f7f7f7
        -webkit-border-radius: 4px
        -moz-border-radius: 4px
        border-radius: 4px
        padding: size(16) size(30)
        font-size size(28)
        line-height 1.5
        color: #999
        word-wrap break-word
        word-break break-all
        span{
          color $color-theme
        }
      }
    }
  }
  .item:before{
    position: absolute;
    right: size(-30);
    bottom: 0;
    left: 0;//size(-30);
    height: 1px;
    content: '';
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    background-color: #e6e6e6;
  }
  .comment{
    position fixed
    bottom: 0
    left 0
    width: 100%
    padding-left: size(30)
    padding-right: size(30)
    padding-bottom: size(10)
    padding-top: size(10)
    font-size size(32)
    background-color: #fff
    z-index 999999
    .wrap{
      display table
      width: 100%
      height: size(70)
      .col{
        display table-cell
        vertical-align middle
        height size(70)
      }
      .col-1{
        widht calc(100% - 3em)
        .textarea{
          width: 100%
          background-color: #f0f0f0
          outline:none
          resize:none
          border: none
          font-size size(28)
          padding: size(0) size(20)
          height size(70)
          vertical-align bottom
          -webkit-border-radius: size(10)
          -moz-border-radius: size(10)
          border-radius: size(10)
          resize none
        }
      }
      .col-2{
        width 3em
        text-align right
        color $color-theme
      }
    }
  }
  /*
  .pinglun-dialog-wrap{
    width: 100%
    .mask{
      display block
      position fixed
      top: 0
      bottom 0
      left 0
      right 0
      z-index 9999
      background-color: rgba(0, 0, 0, .5)
    }
    .content{
      text-align center
      font-size size(28)
      position fixed
      top: size(450)
      left 50%
      z-index 99999
      -webkit-transform: translateX(-50%)
      -moz-transform: translateX(-50%)
      -ms-transform: translateX(-50%)
      -o-transform: translateX(-50%)
      transform: translateX(-50%)
      width 80%
      background-color: #fff
      padding size(30)
      -webkit-border-radius: size(10)
      -moz-border-radius: size(10)
      border-radius: size(10)
      .title{
        margin-bottom: size(40)
      }
      .input-wrap{
        margin-bottom: size(30)
        textarea{
          border: 1px solid #eee
          font-size size(26)
          width 100%
          padding size(20)
          -webkit-border-radius: size(6)
          -moz-border-radius: size(6)
          border-radius: size(6)
          margin-right .4em
          appearance: none
          -webkit-appearance: none
          outline none
          height size(200)
          resize none
        }
      }
      .btns{
        position: relative
        display table
        width 100%
        margin-top: size(30)
        padding-top: size(30)
        .col{
          display table-cell
          width 50%
          vertical-align middle
        }
      }
      .btns:before{
        position: absolute;
        right: size(-30);
        top: 0;
        left: size(-30);
        height: 1px;
        content: '';
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        background-color: #e6e6e6
      }
    }
  } */
  .pinglun-dialog-wrap{
    .mask{
      display block
      position fixed
      top: 0
      bottom 0
      left 0
      right 0
      z-index 999
      background-color: rgba(0, 0, 0, .5)
    }
    .content-t{
      text-align center
      position fixed
      z-index 9999
      background #fff
      width 100%
      left 0
      bottom 0
      padding 0 size(30)
      .title{
        line-height size(106)
        font-size size(36)
      }
      .input-wrap{
        textarea{
          // border: 1px solid #eee
          border: none
          font-size size(26)
          width 100%
          padding size(20)
          -webkit-border-radius: size(6)
          -moz-border-radius: size(6)
          border-radius: size(6)
          margin-right .4em
          appearance: none
          -webkit-appearance: none
          outline none
          height size(200)
          resize none
          background #f7f7f7
          word-wrap break-word
          word-break break-all
        }
      }
      .btns{
        text-align right
        font-size 0
        margin-top size(30)
        margin-bottom size(64)
        .ok{
          display inline-block
          text-align center
          line-height size(56)
          color #ffffff
          background $color-theme
          font-size size(28)
          min-width size(150)
          border-radius 4px
        }
        .cancel{
          position absolute
          right size(30)
          top 0
          padding-top size(24)
          color #999
          padding-left size(32)
          .iconfont{
            font-size size(40)
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/play/play-kcpj.vue